/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import { Grid } from 'src/components/flexible-grid';
import { Row, Image, Toggle } from './styles';

class PersonalizationInterest extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      categories: props.categories.map(category => ({
        ...category,
        removed:
          props.settings.notInterestedIn.categories.findIndex(
            removed => removed.id === category.id
          ) >= 0,
      })),
    };
  }

  toggleInterest(category) {
    if (category.removed) {
      this.addInterest(category);
    } else {
      this.removeInterest(category);
    }
  }

  removeInterest(category) {
    this.setState(prevState => ({
      categories: [
        ...prevState.categories.filter(c => c.id !== category.id),
        { ...category, removed: true },
      ],
    }));
    this.props.removeInterest(category.id);
  }

  addInterest(category) {
    this.setState(prevState => ({
      categories: [
        ...prevState.categories.filter(c => c.id !== category.id),
        { ...category, removed: false },
      ],
    }));
    this.props.addInterest(category.id);
  }

  render() {
    const {
      market: { locale },
      t,
    } = this.context;
    const categories = this.state.categories.sort((a, b) =>
      a.name.localeCompare(b.name, locale.replace('_', '-'))
    );

    return (
      <div>
        <h2>{t('account', 'personalization.interests')}</h2>
        <Grid columnTemplate="repeat(auto-fit, minmax(min(100%, max(300px, 100%/3)), 1fr))">
          {categories.map(category => (
            <Row key={category.id}>
              <div id={`category-${category.id}`}>
                <Image src={category.logo} alt={category.name} />
                {category.name}
              </div>
              <Toggle>
                <label htmlFor={`toggle-${category.id}`}>
                  <input
                    id={`toggle-${category.id}`}
                    aria-labelledby={`category-${category.id}`}
                    type="checkbox"
                    defaultChecked={!category.removed}
                    onChange={() => this.toggleInterest(category)}
                  />
                </label>
              </Toggle>
            </Row>
          ))}
        </Grid>
      </div>
    );
  }
}

PersonalizationInterest.propTypes = {
  categories: PropTypes.array.isRequired,
  settings: PropTypes.shape({
    notInterestedIn: PropTypes.shape({
      categories: PropTypes.array.isRequired,
    }).isRequired,
  }).isRequired,
  removeInterest: PropTypes.func.isRequired,
  addInterest: PropTypes.func.isRequired,
};

PersonalizationInterest.contextType = AppContext;

export default PersonalizationInterest;
